import React, { useState, createContext, useEffect, useMemo, } from "react";
import { useStrapiObjectClass } from "./Hooks";
import { set } from "lodash";
export const GlobalStates = createContext();

const TaskContextProvider = (props) => {
    const [tasks, setTasks] = useState('login');
    const [user, setUser] = useState('');
    const [token, setToken] = useState('');
    const [isLoading, setIsLoading] = useState(true)
    const [type, setType] = useState('')
    const [r, setR] = useState(0)
    const [alert, setAlert] = useState('')
    const [languageG, setLanguageG] = useState('')
    const [path, setPath] = useState(process.env.REACT_APP_API_PATH)
    const [pathImg, setPathImg] = useState(process.env.REACT_APP_API_IMG_PATH)

    const [gyvunai,setGyvunai] = useState([])
    const [savininkai,setSavininkai]=useState([])
    // const {getAll:getSeimininkai}=useStrapiObjectClass({name:'seimininkai',})
    // const { getAll: getAllAnimal } = useStrapiObjectClass({
    //     name: 'Gyvunai',
    //     extraFilter:  ''
    // });
    useEffect(()=>{
        if(user&& user.length>0&& token.length>0&&path){
        // getAllAnimal()
        }
    },[user])


    const value = useMemo(() => ({
        tasks, setTasks,
        user, setUser,
        token, setToken,
        path, setPath,
        pathImg, setPathImg,
        isLoading, setIsLoading,
        type, setType,
        alert, setAlert,
        r, setR,
        languageG, setLanguageG,
        gyvunai, setGyvunai, savininkai, setSavininkai
    }), [tasks, user, token, path, pathImg, isLoading, type, alert, r, languageG, gyvunai, savininkai])

    return (
        <GlobalStates.Provider value={value}>
            {props.children}
        </GlobalStates.Provider>
    );
};

export default TaskContextProvider

